import { render, staticRenderFns } from "./BusinessNote.vue?vue&type=template&id=14282331"
import script from "./BusinessNote.vue?vue&type=script&lang=js"
export * from "./BusinessNote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports